'use client'

import { useEffect, useState } from 'react'
import { motion } from 'motion/react'
import { HedvigPillow } from '@/components/HedvigPillow/HedvigPillow'
import { Text } from 'ui/src/components/Text/Text'
import { type FlowProps } from '../flows.types'
import { badge, badgeText, container, hedvigPillow, iconWrapper, label } from './Flow01Home.css'

// onComplete is part of the shared FlowProps contract but Flow01 is timer-driven
// by the orchestrator, so it is intentionally unused here.
export function Flow01Home(_props: FlowProps) {
  const [step, setStep] = useState<0 | 1 | 2>(0)

  useEffect(() => {
    const popInTimeout = setTimeout(() => setStep(1), 1000)
    const pulseTimeout = setTimeout(() => setStep(2), 3500)
    return () => {
      clearTimeout(popInTimeout)
      clearTimeout(pulseTimeout)
    }
  }, [])

  return (
    <div className={container}>
      <div className={iconWrapper}>
        <HedvigPillow size="medium" className={hedvigPillow} alt="Hedvig" />
        {step >= 1 && (
          <motion.div
            className={badge}
            animate={{ scale: step === 1 ? [0, 1.2, 1] : [1, 1.25, 1] }}
            transition={{
              duration: step === 1 ? 0.25 : 0.3,
              ease: 'easeOut',
              times: step === 1 ? [0, 0.6, 1] : [0, 0.5, 1],
            }}
          >
            <span className={badgeText}>{step}</span>
          </motion.div>
        )}
      </div>
      <Text size="xs" color="textPrimary" className={label}>
        Hedvig
      </Text>
    </div>
  )
}
